import { useState, useEffect } from "react";
import { AxiosError } from "axios";
import axiosInstance from "../shared/axiosInstance";

export const useGetService = (url?: string, skipFetch?: boolean) => {
  const [response, setResponse] = useState<any>();
  const [error, setError] = useState<AxiosError>();
  const [detailedError, setDetailedError] = useState<AxiosError>();
  const [isLoading, setIsLoading] = useState(false);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await axiosInstance.get(
        process.env.REACT_APP_BASE_URL + "/" + url
      );
      setResponse(result.data);
      setError(undefined);
      setDetailedError(undefined);
    } catch (err: any) {
      setError(err?.message);
      setDetailedError(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (url && !skipFetch) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, skipFetch]);

  // Refetch data
  const refetch = async (updatedURL: string, silentFetch?: boolean) => {
    if (skipFetch) {
      return;
    }
    setIsLoading(!silentFetch);
    try {
      const result = await axiosInstance.get(
        process.env.REACT_APP_BASE_URL + "/" + updatedURL
      );
      setResponse(result.data);
      setError(undefined);
      setDetailedError(undefined);
      return result;
    } catch (err: any) {
      setError(err?.message);
      setDetailedError(err);
      setResponse(undefined);
    } finally {
      setIsLoading(false);
    }
  };

  const manualUpdateResp = (data: any) => {
    setResponse(data);
  }

  return { response, error, isLoading, refetch, detailedError, manualUpdateResp };
};
